// Qué cookies aceptó el visitante. Las esenciales van siempre; la publicidad
// (pixel de Meta del organizador) y la analítica sólo si las acepta.
// Se guarda en una cookie por 180 días.

export const COOKIE = "pg_consentimiento";
export const VERSION = 1;
const DIAS = 180;
export const EVENTO_CAMBIO = "pg-consentimiento";
export const EVENTO_ABRIR = "pg-abrir-preferencias-cookies";

export const leer = (cookies = typeof document !== "undefined" ? document.cookie : "") => {
  const par = cookies.split("; ").find((c) => c.startsWith(`${COOKIE}=`));
  if (!par) return null;
  try {
    const valor = JSON.parse(decodeURIComponent(par.slice(COOKIE.length + 1)));
    return valor && valor.version === VERSION ? valor : null;
  } catch {
    return null;
  }
};

export const armar = ({ publicidad = false, analitica = false } = {}, ahora = Date.now()) => ({
  version: VERSION,
  publicidad: Boolean(publicidad),
  analitica: Boolean(analitica),
  fecha: new Date(ahora).toISOString(),
});

export const guardar = (elecciones) => {
  const valor = armar(elecciones);
  const vence = new Date(Date.now() + DIAS * 24 * 60 * 60 * 1000).toUTCString();
  const seguro = window.location.protocol === "https:" ? "; Secure" : "";
  document.cookie = `${COOKIE}=${encodeURIComponent(JSON.stringify(valor))}; expires=${vence}; path=/; SameSite=Lax${seguro}`;
  window.dispatchEvent(new CustomEvent(EVENTO_CAMBIO, { detail: valor }));
  return valor;
};

export const aceptaPublicidad = (consentimiento = leer()) => Boolean(consentimiento?.publicidad);

export const abrirPreferencias = () => window.dispatchEvent(new CustomEvent(EVENTO_ABRIR));
